import { eventRoute } from "Constants";

let routeName= process.env.NODE_ENV ===  'development' ? `/${eventRoute}` : '';
let homeRoute = process.env.NODE_ENV ===  'development' ? `${eventRoute}` : '';

export {routeName, homeRoute}